import axios from "axios";
import * as constants from "../Constatnts";
import * as actionTypes from "../actionTypes";
// Helper to safely get token
const getTokenFromState = (getState) => {
  const state = getState();
  let token = "";

  if (
    state &&
    state.hasOwnProperty("user") &&
    state.user &&
    state.user.hasOwnProperty("uat")
  ) {
    token = state.user.uat;
  }

  return token;
};

// Common error handler (NO optional chaining)
const handleError = (error) => {
  if (
    error &&
    error.hasOwnProperty("response") &&
    error.response &&
    error.response.hasOwnProperty("data")
  ) {
    throw error.response.data;
  } else {
    throw error;
  }
};

// ================= API FUNCTIONS ================= //


export function getWhatsappActiveProvider (key)  {
  return async (dispatch, getState) => {
    try {
      const token = getTokenFromState(getState);

      const response = await axios.get(
        `${constants.API_URL}/whatsapp/active/provider?registrationId=${key}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );


      
      let whatsappProvider=response.data.data || {};

       dispatch({
              type: actionTypes.GET_WHATSAPP_ACTIVE_PROVIDER,
              whatsappActiveProvider:whatsappProvider,
            });
      return response.data;
    } catch (error) {
      handleError(error);
    }
  };
};
export function getWhatsappAllProviders (key)  {
  return async (dispatch, getState) => {
    try {
      const token = getTokenFromState(getState);

      const response = await axios.get(
        `${constants.API_URL}/whatsapp/providers?registrationId=${key}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleError(error);
    }
  };
};

export function getWalletBalance(key){
  return async (dispatch, getState) => {
    try {
      const token = getTokenFromState(getState);

      const response = await axios.get(
        `${constants.API_URL}/whatsapp/wallet?registrationId=${key}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleError(error);
    }
  };
};

export const getHistoryData = (campaignId, runDate) => {
  return async (dispatch, getState) => {
    try {
      const token = getTokenFromState(getState);

      const response = await axios.get(
        `${constants.API_URL}/run-history/messages?campaignId=${campaignId}&runDate=${runDate}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleError(error);
    }
  };
};

export const updateCredentials = (_id, payloadCredentials) => {
  return async (dispatch, getState) => {
    try {
      const token = getTokenFromState(getState);

      const response = await axios.put(
        `${constants.API_URL}/whatsapp/provider/edit/${_id}`,
        { credentials: payloadCredentials },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleError(error);
    }
  };
};

export const updateProvider = (_id, payload) => {
  return async (dispatch, getState) => {
    try {
      const token = getTokenFromState(getState);

      const response = await axios.put(
        `${constants.API_URL}/whatsapp/provider/edit/${_id}`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleError(error);
    }
  };
};

export const toggleProvidersActive = (providerId) => {
  return async (dispatch, getState) => {
    try {
      const token = getTokenFromState(getState);

      // ❗ FIX: PUT second argument must be body, headers go in 3rd param
      const response = await axios.put(
        `${constants.API_URL}/whatsapp/provider/toggle-active/${providerId}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleError(error);
    }
  };
};

export const setupCredentials = (
  payloadCredentials,
  registrationId,
  provider
) => {
  return async (dispatch, getState) => {
    try {
      const token = getTokenFromState(getState);

      const response = await axios.post(
        `${constants.API_URL}/whatsapp/provider/setup`,
        {
          registrationId,
          provider,
          credentials: payloadCredentials,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleError(error);
    }
  };
};

export const getTemplates = (
  providerId,
  templateType,
  registrationId
) => {
  return async (dispatch, getState) => {
    try {
      const token = getTokenFromState(getState);

      if (!registrationId) {
        registrationId = "";
      }

      const response = await axios.get(
        `${constants.API_URL}/templates/${providerId}/${templateType}?registrationId=${registrationId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleError(error);
    }
  };
};

export const togglePosibleTemplateStatus = (payload) => {
  return async (dispatch, getState) => {
    try {
      const token = getTokenFromState(getState);

      const response = await axios.post(
        `${constants.API_URL}/template/posible/toggle-status`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleError(error);
    }
  };
};

export const createTemplate = (payload) => {
  return async (dispatch, getState) => {
    try {
      const token = getTokenFromState(getState);

      const response = await axios.post(
        `${constants.API_URL}/template/create`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleError(error);
    }
  };
};

export const updateTemplate = (payload) => {
  return async (dispatch, getState) => {
    try {
      const token = getTokenFromState(getState);

      const response = await axios.put(
        `${constants.API_URL}/template/update`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleError(error);
    }
  };
};

export const deleteTemplate = (templateMongoId) => {
  return async (dispatch, getState) => {
    try {
      const token = getTokenFromState(getState);

      const response = await axios.delete(
        `${constants.API_URL}/template/${templateMongoId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleError(error);
    }
  };
};

export const getEventVariables = (eventName) => {
  return async (dispatch, getState) => {
    try {
      const token = getTokenFromState(getState);

      if (!eventName) {
        eventName = "";
      }

      // ❗ FIX: was DELETE → should be GET
      const response = await axios.get(
        `${constants.API_URL}/template/variables?eventName=${eventName}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleError(error);
    }
  };
};